import api from "./api";

// Function to fetch books from the server
export const fetchBooksFromAPI = async (languageIds) => {
  try {
    const response = await api.get(`/polyglot/books`, {});

    // Validate response status
    if (response.status !== 200) {
      throw new Error(
        `Failed to fetch books: ${response.status} ${response.statusText}`
      );
    }

    // Validate response data
    if (!response.data || !Array.isArray(response.data)) {
      throw new Error("Invalid response format: Expected an array of books");
    }

    // Assuming the response data contains the books, return the data
    return response.data;
  } catch (error) {
    console.error("fetchLanguagesFromAPI Error:", error.message);
    throw error; // Re-throw for saga to handle
  }
};
